(function () {
  const root = document.querySelector('[data-referral-announcement]');
  if (!(root instanceof HTMLElement)) return;

  const code = root.dataset.code;
  if (!code) return;

  const STORAGE_KEY = 'ascent-referral-applied';
  let applied = '';
  try {
    applied = sessionStorage.getItem(STORAGE_KEY) ?? '';
  } catch {
    // Storage blocked: the link's ref still works for this page view.
  }

  const fromLink = (new URLSearchParams(window.location.search).get('ref') ?? '').toLowerCase();
  const ref = /^[a-z0-9-]{1,40}$/.test(fromLink) ? fromLink : applied;
  if (!ref) return;

  root.hidden = false;

  /** Writes the referrer and the code to the cart unless both are already there. */
  async function ensureOnCart() {
    const cart = await fetch('/cart.js').then((response) => response.json());
    const hasRef = cart.attributes?._referrer === ref;
    const hasCode = (cart.discount_codes ?? []).some(
      (/** @type {{ code: string }} */ entry) => entry.code.toLowerCase() === code?.toLowerCase()
    );
    if (hasRef && hasCode) return;

    await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { _referrer: ref }, discount: code }),
    });
  }

  async function apply() {
    if (applied !== ref) {
      // The discount cookie covers express checkout buttons, which skip the cart.
      await fetch(`/discount/${encodeURIComponent(code ?? '')}?redirect=%2Fcart.js`).catch(() => {});
    }

    await ensureOnCart();
    try {
      sessionStorage.setItem(STORAGE_KEY, ref);
    } catch {
      // Storage blocked: the next page view applies the code again, which is harmless.
    }

    // Other scripts on the page can replace the whole attribute set while it loads, so check once more.
    setTimeout(() => {
      ensureOnCart().catch(() => {});
    }, 4000);
  }

  apply().catch(() => {});
})();
